import { autoinject, transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { DocumentAccessApi } from "../../../apis/document-access.api";
import { GoogleAnalyticsService } from "@rightship-tech/common-ui/services/analytics/google-analytics.service";

@autoinject
@transient()
export class DialogRequestAccess {

    private _requirementCustomerName: string;
    public message: string = "";
    public isForm: boolean = false;
    public itemId: number;
    public vesselId: number;
    public vesselName: string;
    public vesselImo: string;
    public documentName: string;
    onSave: () => void;

    constructor(public dialogClientService: DialogClientService, private documentAccessApi: DocumentAccessApi, 
        private notificationClientService: NotificationClientService, private googleAnalyticsService: GoogleAnalyticsService) {}

    activate(model: { isForm: boolean, itemId: number, vesselId: number, vesselName: string, vesselImo: string, documentName: string, requirementCustomerName: string, onSave: () => void }) {
        this.isForm = model.isForm;
        this.itemId = model.itemId;
        this.vesselId = model.vesselId;
        this.vesselName = model.vesselName;
        this.vesselImo = model.vesselImo;
        this.documentName = model.documentName;
        this._requirementCustomerName = model.requirementCustomerName;
        this.onSave = model.onSave;
    }

    //Request access
    async requestAccess() {
        try {
            if (this.isForm) {
                await this.documentAccessApi.requestFormAccess({
                    vesselFormId : this.itemId,
                    message : this.message,
                    itemName : this.documentName,
                    vesselName : this.vesselName,
                    vesselImo : this.vesselImo
                })
            }
            else {
                await this.documentAccessApi.requestDocumentAccess({
                    vesselDocumentId : this.itemId,
                    message : this.message,
                    itemName : this.documentName,
                    vesselName : this.vesselName,
                    vesselImo : this.vesselImo
                })
            }
            if(this.onSave) {
                this.onSave();
            }
            this.notificationClientService.show("Request access has been sent successfully", "", NotificationType.Success);

            //Send event to google analytics
            this.googleAnalyticsService.sendCustomGA4EventMulti("dmc_view_docs_request_access_submit", {
                "charterer": this._requirementCustomerName,
                "documentName": this.documentName
            });
            
            //Hide dialog
            this.dialogClientService.hide(true);
        }
        catch (error) {
            console.log(error)
            this.notificationClientService.show("An error occurd when trying to send request access", "", NotificationType.Error);
        }
    }

    //Cancel
    cancel() {

        //Send event to google analytics
        this.googleAnalyticsService.sendCustomGA4EventMulti("dmc_view_docs_request_access_cancel", {
            "charterer": this._requirementCustomerName,
            "documentName": this.documentName
        });

        //Hide dialog
        this.dialogClientService.hide();
    }
}